<template>
    <div class="mb-3">
        <b for="name" v-if="label" class="form-label">{{ label }}</b>
        <input type="text" :placeholder="label" :disabled="disabled" :readonly="readonly" :value="modelValue"
            @input="handleInput($event)" @keypress="isFloat($event)" class="form-control" />
        <span class="text-danger" v-for="error in v?.$errors" :key="error.$uid">
            - {{ error.$message }} <br>
        </span>
    </div>


</template>

<script setup lang="ts">
import { defineProps, ref, defineEmits } from 'vue';

const props = defineProps({
    modelValue: {
        type: Number,
        default: 0,
    },
    label: String,
    placeholder: {
        type: String,
        default: 'Enter price',
    },
    disabled: Boolean,
    readonly: Boolean,
    v: {
        type: Object,
    }
});

const emits = defineEmits(['update:modelValue']);
const handleInput = (event) => {
    emits('update:modelValue', event.target.value);
}

const isFloat = (event) => {
    const keyCode = event.keyCode ? event.keyCode : event.which;
    const currentValue = event.target.value;
    // Allow only numbers (0-9) and a single decimal point (.)
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        event.preventDefault();
    }
    // Check if there is already a decimal point in the input
    if (currentValue.indexOf('.') !== -1 && keyCode === 46) {
        event.preventDefault();
    }
};

</script>